module.exports = "/images/media-event.svg?4279e32964232eda7207ba370fad27f1";